import React from 'react'
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const GamePlayer = (props) => {
  return (
    <div className='popup-box'>
        <h4 className="title">{props.t('attention')} !</h4>
        <p>{props.t('an_issue_has_been_detected_with_your_account')},</p>
        <p>{props.t('please_reach_out_to_your_service_provider_for_assistance_through_live_chat')}.</p>
        <p>{props.t('thank_you_for_your_cooperation')}.</p>
    </div>
  )
}

GamePlayer.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
  };

export default withTranslation()(GamePlayer);